module.exports = __webpack_public_path__ + "static/media/CasaLogo.e2a11713.svg";